import { Component, OnInit } from '@angular/core';
import { LoginResponse } from '../../constants/LoginResponse';
import { AuthService } from '../../service/auth.service';
import { Router, RouterModule } from '@angular/router';
import { PAGE_SCREEN } from '../../constants/PAGE_SCREEN';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  standalone: true,
  imports: [FormsModule, RouterModule],
  styleUrls: [
    '../../../../assets/bootstrap/bootstrap.css',
    './delete-account.component.scss',
  ],
})
export class DeleteAccountComponent implements OnInit {
  username: string = '';
  password: string = '';
  confirmPassword: string = '';
  loading: boolean = false;
  errorMsg: string = '';
  loginResponse: LoginResponse | null = null;
  screenName = PAGE_SCREEN.LOGIN_PAGE;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {}

  onSubmitForm() {
    let emailPattern = new RegExp(
      '^[a-zA-Z0-9_+&*-]+(?:\\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,7}$'
    );
    if (!emailPattern.test(this.username)) {
      this.errorMsg = 'Enter a valid email address';
      return;
    }

    this.loading = true;
    this.authService
      .deleteAccountLoginAPI(this.username, this.password)
      .then((res: LoginResponse) => {
        console.log(res);
        this.loginResponse = res;
        this.screenName = PAGE_SCREEN.CONFIRM_PASS;
        this.loading = false;
      })
      .catch((msg: string) => {
        this.loading = false;
        if (msg) {
          if (msg == 'User Not Found') {
            this.errorMsg = 'User not found';
            return;
          }
          if (msg == 'Password do not match') {
            this.errorMsg = 'Invalid password';
            return;
          }
        }
      });
  }

  getFirstLetter(name: any) {
    return name ? name?.charAt(0).toUpperCase() : '';
  }

  onDeleteUserAccount() {
    if (this.password != this.confirmPassword) {
      this.errorMsg = 'Passwords do not match';
      return;
    }

    if (confirm('Are you sure you want to delete your account?')) {
      this.loading = true;
      if (this.loginResponse?.auth?.token) {
        this.authService
          .deleteUserAPI(this.loginResponse?.auth?.token)
          .then((res: any) => {
            console.log(res);
            if (res?.message == 'Deleted successfully') {
              this.loading = false;
              this.username = '';
              this.password = '';
              this.confirmPassword = '';
              this.errorMsg = '';
              this.loginResponse = null;
              this.screenName = PAGE_SCREEN.SUCCESS_MSG;
            } else {
              this.loading = false;
              this.errorMsg = 'Something went wrong, Try again later';
            }
          })
          .catch((err) => {
            console.error(err);
            this.loading = false;
            this.errorMsg = 'Something went wrong, Try again later';
            if (err == 'cannot delete an owner account') {
              this.errorMsg = 'Cannot delete an owner account';
            }
          });
      }
    }
  }

  onGoBackPressed() {
    this.screenName = PAGE_SCREEN.LOGIN_PAGE;
    this.router.navigateByUrl('/');
  }
}
